<template>
  <v-app>
    <!--INDICA LA PÁGINA EN LA QUE SE ENCUETRA-->
    <v-card class="grlCardInfo">
      <v-breadcrumbs :items="obtRuta" class="grlClase">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item @click="insertarRuta(item.ruta)" :disabled="item.disabled">
            {{ item.text.toUpperCase() }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </v-card>
    <!--IMAGEN Y TITULO DE LA PÁGINA-->
    <v-card>
      <v-img :src="imgTitle" class="grlCardImg">
        <div class="grlCardInfo">
          <h1 class="my-auto hidden-sm-and-down">Publicaciones</h1>
        </div>
      </v-img>
    </v-card>
    <!--CONTENEDOR QUE MUESTRA LAS DOS IMAGENES QUE TE LLEVAN A OTRO PÁGINA-->
    <div class="gralMargenes" id="gralEspaciado">
      <v-row>
        <v-col v-for="item in publicaciones" :key="item.id" cols="12" md="6">
          <h3>{{item.title}}</h3>
          <hr>
          <v-card class="pubContImg">
            <a :href="item.link" target="_blank">
              <v-img contain class="pubEstiloImg" :src="item.src"></v-img>
            </a>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-app>
</template>
<script>

export default {
  name: 'PagInicio',
  data() {
    return {
      publicaciones: [
        {
          id: 1,
          title: 'Revista agrofaz',
          src: require('../../assets/img/agrofaz2023.jpg'),
          link: 'http://www.agrofaz.net/index.php/agrofaz',
        },
        {
          id: 2,
          title: 'Semana Internacional de Agronomía',
          src: require('../../assets/img/sia36.png'),
          link: 'https://sci-platform.org/sia/',
        },
      ],
      imgTitle: require('../../assets/img/banner-docenteFaz.jpeg'),
      obtRuta: [
        {
          text: 'Inicio',
          disabled: false,
          ruta: '/',
        },
        {
          text: 'Conócenos',
          disabled: true,
          ruta: '/',
        },
        {
          text: 'Publicaciones',
          disabled: true,
          ruta: '/',
        },
      ],
    };
  },
  methods: {
    insertarRuta(ruta) {
      this.$router.push(ruta);
    },
  },
};
</script>
